module.exports = __webpack_public_path__ + "img/pre_point.6e052846.svg";